{
  "review_contacts_table": {
    "clear_selection": "Effacer la sélection",
    "alert_message": "Examinez et gérez vos contacts entrants ici. En sélectionnant la case à côté d'un contact, vous pouvez les publier dans le CRM, les définir comme privés ou archiver leurs détails.",
    "contacts_selected": "{{count}} contacts sélectionnés",
    "contact_column": "Contact",
    "company_column": "Société",
    "location_column": "Lieu",
    "tags_column": "Tags",
    "last_interaction_column": "Dernière interaction"
  },
  "allow_marketing": {
    "success_description": "Ces contacts sont maintenant autorisés pour le marketing !"
  },
  "set_as_private": {
    "confirm_title": "Définir les contacts comme privés",
    "confirm_content": "Toutes les interactions futures (par ex. fil d'activité, qui connaît) vous incluant et ces contacts ne seront pas suivies.",
    "delete_past_interactions": "Supprimer les interactions passées entre vous et ce contact. Cette action est irréversible.",
    "remove_from_my_contacts": "Retirer de Mes contacts",
    "button": "Définir comme privé",
    "success_description": "Ces contacts ont été définis comme privés."
  }
}
